export const mutations = {
  setServiceList (state, serviceList) {
    state.serviceList = serviceList
  },
  setSearch (state, payload) {
    state.searchData.loading = !state.searchData.loading
    state.searchData = Object.assign({}, state.searchData, payload)
  }
}
